module.exports = __webpack_public_path__ + "img/Sandrine-Azhar@2x.e2b16e8e.png";